<div class="app-container">
    <router-outlet></router-outlet>
</div>

<!-- Tutorial Modal - renders globally for all routes -->
<app-tutorial-modal></app-tutorial-modal>
